import { render } from "./Index.vue?vue&type=template&id=1d2ca719&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1d2ca719&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2ca719"]])

export default __exports__